import { render, staticRenderFns } from "./GoTop.vue?vue&type=template&id=6061d7d4"
import script from "./GoTop.vue?vue&type=script&lang=js"
export * from "./GoTop.vue?vue&type=script&lang=js"
import style0 from "./GoTop.vue?vue&type=style&index=0&id=6061d7d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports